import { render, staticRenderFns } from "./CardItemHospitalCollapse.vue?vue&type=template&id=1bf0620a&scoped=true"
import script from "./CardItemHospitalCollapse.vue?vue&type=script&lang=js"
export * from "./CardItemHospitalCollapse.vue?vue&type=script&lang=js"
import style0 from "./CardItemHospitalCollapse.vue?vue&type=style&index=0&id=1bf0620a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0620a",
  null
  
)

export default component.exports